import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // 判断当前路径是否激活
  const isActive = (href:string) => location.pathname === href;

  return (
    <nav className="bg-white shadow-sm">
      <div className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <a href="/" className="text-xl font-bold text-red-500">
            XHS Lingo
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6 items-center">
            <a
              href="/"
              className={`text-sm ${
                isActive("/") ? "text-red-500" : "text-gray-600 hover:text-red-500"
              }`}
            >
              Home
            </a>
            <a
              href="/rednote-hashtag-finder"
              className={`text-sm ${
                isActive("/rednote-hashtag-finder")
                  ? "text-red-500"
                  : "text-gray-600 hover:text-red-500"
              }`}
            >
              Hashtag Finder
            </a>
            <a
              href="/blogs"
              className={`text-sm ${
                isActive("/blogs")
                  ? "text-red-500"
                  : "text-gray-600 hover:text-red-500"
              }`}
            >
              Blogs
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-gray-600 hover:text-red-500 focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden mt-4 bg-white shadow-md rounded-lg">
            <a
              href="/"
              className={`block px-4 py-2 ${
                isActive("/") ? "text-red-500" : "text-gray-600 hover:bg-red-50 hover:text-red-500"
              }`}
            >
              Home
            </a>
            <a
              href="/rednote-hashtag-finder"
              className={`block px-4 py-2 ${
                isActive("/rednote-hashtag-finder")
                  ? "text-red-500"
                  : "text-gray-600 hover:bg-red-50 hover:text-red-500"
              }`}
            >
              Hashtag Finder
            </a>
            <a
              href="/blogs"
              className={`block px-4 py-2 ${
                isActive("/blogs")
                  ? "text-red-500"
                  : "text-gray-600 hover:bg-red-50 hover:text-red-500"
              }`}
            >
              Blogs
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;